const initialState = {
  user: "",
  isUserLoaded: false,
  autos: [],
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_AUTOS":
      return { ...state, autos: action.payload };
    case "SET_USER_LOADED":
      return { ...state, isUserLoaded: action.payload };
    default:
      return state;
  }
};
